//jQuery
import jQuery from 'jquery'

//Bootstrap
import 'bootstrap/js/src/alert'
import 'bootstrap/js/src/collapse'
import 'bootstrap/js/src/dropdown'

//Wirebox core
import EventBus from '../../shared/js/wirebox/event-bus'

//Wirebox components
import '../../shared/js/wirebox/components/csrf-token'

//Shared components
import '../../shared/js/components/cloning'
import '../../shared/js/components/file-upload'
import '../../shared/js/components/form-validation'
import '../../shared/js/components/multiselect'

//Wirebox utilities
import '../../shared/js/wirebox/utilities/sticky-footer'

//Components
import './components/history'
import './components/maps'
import './components/tooltips'

//Modules
import './modules/funders/list'
import './modules/funders/map'
import './modules/modals/survey-success'
import './modules/survey/document-uploads'
import './modules/training/bookmark-btn'
import './modules/training/list'

//Run modules
EventBus.run()